import React from "react";
import { useParams, Link } from "react-router-dom";
import projects from "../data/projects";

const ProjectDetails = () => {
  const { id } = useParams();
  const project = projects.find((p) => p.id === parseInt(id));

  if (!project) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <h2 className="text-2xl font-semibold">Project not found</h2>
      </div>
    );
  }

  // Define features for Homes For Rent
  const features =
    project.title === "Homes For Rent"
      ? [
          "3 bedrooms",
          "Fitted kitchen",
          "Maids / storage room",
          "Free water supply",
          "Standby generator",
          "24/7 security service",
          "Electric fencing",
          "CCTV surveillance",
          "Ample parking space",
          "Spacious living and dining areas",
          "Modern bathroom fittings",
          "Balcony with scenic views",
        ]
      : null;

  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="relative w-full h-[50vh] flex items-center justify-center">
        <img
          src={project.images && project.images[0] ? project.images[0] : "/images/header.jpg"}
          alt={project.title}
          className="absolute top-0 left-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50"></div>
        <h1 className="relative z-10 text-4xl md:text-6xl font-bold text-white">
          {project.title}
        </h1>
      </div>

      {/* Content */}
      <div className="max-w-6xl mx-auto px-6 py-16 space-y-10">
        {/* Description */}
        <p className="text-lg text-gray-700">{project.details}</p>

        {/* Video / Gallery */}
        {project.video ? (
          <div>
            <video
              src={project.video}
              controls
              playsInline
              className="w-full h-[400px] md:h-[500px] object-cover rounded-xl shadow-md"
              poster={project.images && project.images[0] ? project.images[0] : "/images/redsolonetrent.png"}
            >
              Sorry, your browser doesn't support embedded videos.
            </video>

            {project.images && project.images.length > 0 && (
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
                {project.images.map((img, index) => (
                  <img
                    key={index}
                    src={img}
                    alt={`${project.title} ${index + 1}`}
                    className="rounded-xl shadow-md object-cover w-full h-64"
                  />
                ))}
              </div>
            )}
          </div>
        ) : project.images && project.images.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {project.images.map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`${project.title} ${index + 1}`}
                className="rounded-xl shadow-md object-cover w-full h-64"
              />
            ))}
          </div>
        ) : (
          <div className="w-full h-[400px] flex items-center justify-center bg-gray-200 rounded-xl">
            <span className="text-gray-500">No media available</span>
          </div>
        )}

        {/* Features */}
        {features && (
          <div>
            <h2 className="text-2xl font-semibold mb-4">Property Features</h2>
            <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 list-disc list-inside text-gray-700">
              {features.map((feature, idx) => (
                <li key={idx}>{feature}</li>
              ))}
            </ul>
          </div>
        )}

        {/* Contact Details */}
        {project.title === "Homes For Rent" && (
          <div className="mt-8 p-6 bg-white rounded-xl shadow-md">
            <h2 className="text-2xl font-semibold mb-4">Contact Details</h2>
            <p className="text-gray-700">
              <strong>Phone:</strong> +233 53 406 5455
            </p>
            <p className="text-gray-700">
              <strong>Email:</strong> solonetgh@gmail.com
            </p>
            <p className="text-gray-700">
              <strong>Address:</strong> Burma Hills, Tse Addo, Accra, Ghana
            </p>
          </div>
        )}

        {/* Back Button */}
        <div className="mt-10">
          <Link
            to="/projects"
            className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
          >
            ← Back to Projects
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetails;
